export const content = {
    domain: "Lendmarkfinancial",
    footer: "lendmaksfinancial.com",
    title1: "The Funds You Need Fast",
  };
  